import { useNavigate, useParams } from "react-router-dom";
import Api from "../../Api";
import Section from "../../parts/Section";
import ClientBar from "../../parts/ClientBar";
import ReceiptsFormContract from "./FormContract";
import { useEffect, useState } from "react";
import ContentAsync from "../../parts/ContentAsync";
import moment from "moment";
import { Client, RentContract, RentContractUI, UIValue } from "../../types";
import { brlToInt } from "../../utils";

const FinanceContractCreate = () => {
  const { clientUuid } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [client, setClient] = useState<Client | null>(null);
  const [contract, setContract] = useState<RentContractUI>({
    uuid: "",
    clientUuid: "",
    startDate: moment().format("YYYY-MM-DD"),
    expirationDay: moment().format("DD"),
    serviceAlarm: false,
    serviceCamera: false,
    amount: "",
    emails: [],
    suspended: false,
    equipments: [],
    note: "",
    noteClient: "",
    client: {
      name: "",
      type: "",
      document: "",
      street: "",
      number: "",
      zipcode: "",
      city: "",
      state: "",
    },
  });

  const changeContract =
    (key: keyof RentContract) => (value: UIValue | string[]) => {
      setContract((contract) => ({ ...contract, [key]: value }));
    };

  useEffect(() => {
    Api.financeContractClient(clientUuid!).then(({ client }) => [
      setClient(client),
      changeContract("emails")([client.email]),
      changeContract("clientUuid")(client.uuid),
      setLoading(false),
    ]);
  }, [clientUuid]);

  const createContract = async () => {
    setError(false);

    const payload: RentContract = {
      ...contract,
      startDate: moment(contract.startDate).toDate(),
      expirationDay: parseInt(contract.expirationDay),
      amount: brlToInt(contract.amount),
    };
    const result = await Api.financeCreateContract(payload);
    result.success
      ? navigate(`/financeiro/contrato/${result.uuid}`)
      : setError(true);
  };

  return (
    <ContentAsync loading={loading}>
      {client && (
        <ClientBar
          action="Adicionando contrato para"
          client={client.name}
          url={`/financeiro/contratos/cliente/${client.uuid}`}
        />
      )}

      {client && (
        <Section>
          <ReceiptsFormContract
            contract={contract}
            changeContract={changeContract}
            onSubmit={createContract}
            error={error}
          />
        </Section>
      )}
    </ContentAsync>
  );
};

export default FinanceContractCreate;
